import { Injectable } from '@angular/core';
import { WebApiClient } from '../../web-api-client.service';
import { WebApiService } from '../../web-api.service';
import { ProductBatchDto, AvailableBatchDto, InactiveBatchDto, ProductBatchQuery } from 'src/app/stocks/product-batch/models/product-batch';

@Injectable({ providedIn: 'root' })
export class ProductBatchApi {
  private apiService: WebApiService;

  constructor(private apiClient: WebApiClient) {
    this.apiService = this.apiClient.createHisService('Stocks/ProductBatch');
  }

  GetAll(query: ProductBatchQuery) {
    // 缺欄位一律送空字串, 避免 undefined 被序列化成 "undefined" 而被後端當篩選值
    const payload: any = {
      productCode: query.productCode?.trim() ?? '',
      productName: query.productName?.trim() ?? '',
      batchNo: query.batchNo?.trim() ?? '',
      expirationDateStart: query.expirationDateStart ?? '',
      expirationDateEnd: query.expirationDateEnd ?? '',
      includeStopped: query.includeStopped ?? false,   // 通用安全預設; 維護頁(GetAll)與 GetByProduct 都明確傳 true
      orderBy: query.orderBy ?? '',
      orderDesc: query.orderDesc ?? false,
      pageSkip: query.pageSkip ?? 0,
      pageSize: query.pageSize ?? 20
    };
    // 停用狀態三態篩選: 有值才帶 (不帶=後端 null=不篩選)
    if (query.isStopBatch !== undefined) {
      payload.isStopBatch = query.isStopBatch;
    }
    return this.apiService.get('GetAll', payload).toPromise<any>();
  }

  /** 批次儲存 (批次編輯模式) */
  BatchSave(dtos: Partial<ProductBatchDto>[]) {
    return this.apiService.post('BatchSave', dtos).toPromise<any>();
  }

  /** 批次新增 (同一商品多筆批號) */
  BatchCreate(dtos: Partial<ProductBatchDto>[]) {
    return this.apiService.post('BatchCreate', dtos).toPromise<any>();
  }

  Delete(id: number) {
    return this.apiService.delete(`Delete/${id}`).toPromise<void>();
  }

  /** 取得閒置批號 (未停用、建檔滿3個月、期間無單據異動且庫存量為 0; 供進頁停用建議 dialog) */
  GetInactiveBatches() {
    return this.apiService.get('GetInactiveBatches').toPromise<InactiveBatchDto[]>();
  }

  /** 批次停用批號 (停用建議 dialog 勾選停用) */
  BatchStop(ids: number[]) {
    return this.apiService.post('BatchStop', ids).toPromise<any>();
  }

  GetAvailableBatches(productId: number, storeRoomId: number) {
    return this.apiService.get('GetAvailableBatches', { productId, storeRoomId }).toPromise<AvailableBatchDto[]>();
  }

  /** 取得某商品的全部批號 (含停用; 供新增 dialog 偵測與既有批號重複) */
  GetByProduct(productId: number) {
    const payload = {
      productId,
      includeStopped: true,
      pageSkip: 0,
      pageSize: 9999
    };
    return this.apiService.get('GetAll', payload).toPromise<any>();
  }
}
